import { Component, Inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormGroup, FormBuilder, AbstractControl, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatOption } from '@angular/material/core';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle, MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { ApplicationDataService } from '../../../../core/services/application-data.service';
import { AlertDialogComponent } from '../../../../shared/alert-dialog/alert-dialog.component';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-send-email-dialog',
  standalone: true,
  imports: [
    FormsModule,
    MatButton,
    MatCheckbox,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatError,
    MatFormField,
    MatInput,
    MatLabel,
    MatOption,
    MatSelect,
    ReactiveFormsModule,
    TranslateModule,
    NgIf
  ],
  templateUrl: './send-email-dialog.component.html',
  styleUrl: './send-email-dialog.component.css'
})
export class SendEmailDialogComponent {
  form: FormGroup;
  TITLE: string;
  SEND_TO_LABEL: string;
  private fullEmail: string = '';


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SendEmailDialogComponent>,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private appDataService: ApplicationDataService
  ) {
    this.fullEmail = data.fullEmail;
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      sendTo: [{ value: '', disabled: true }, [Validators.required, Validators.maxLength(30), Validators.email]],
      complaintId: [''],
      subject: ['', [Validators.required]],
      message: ['', [Validators.required]],
    });

    // Set the masked display value but keep full email internally
    this.form.patchValue({
      sendTo: this.data.sendTo,
      complaintId: this.data.complaintId
    });

    this.TITLE = this.data.title;
    this.SEND_TO_LABEL = this.data.sendToLabel;
  }

  onSubmit() {
    if (this.form.invalid) {
      return;
    }

    // Get form values
    const formValue = this.form.getRawValue();

    // Remove the `sendTo` field from the payload
    const { sendTo, ...payloadWithoutSendTo } = formValue;

    this.appDataService.sendEmailService(payloadWithoutSendTo).subscribe({
      next: (response) => {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          data: {
            message: "Email Sent Successfully!",
            buttonText: {
              cancel: 'OK'
            }
          },
        });
        this.dialogRef.close();
      },
      error: (error) => {
        this.dialog.open(AlertDialogComponent, {
          data: {
            message: error?.error?.message || "Failed to send email. Please try again.",
            buttonText: {
              cancel: 'OK'
            }
          },
        });
        // Do not close the dialog so the user can retry
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }
}